import * as angular from 'angular';
import * as d3 from 'd3';
import * as _ from 'lodash';

import { ComponentDefinition, DataType, DigitalSet, IDateRange, IValueViewModel, KeyValuePair, TagManualInputValues } from '../../models';
import { IManualInputsService, ILoggerService, IBulkManualInputValues } from '../../services';
import { guidEmpty } from '../../common';

class ManualBulkInputModalController implements angular.IComponentController {
    bulkInputRows: any[];
    isLoading: boolean;
    currentBeginDate;
    currentEndDate;
    initialRange: IDateRange;
    includeEndDate: boolean;
    inputList: TagManualInputValues[];
    isRefreshPrevented: boolean = true;
    digitalsSets: DigitalSet[];

    confirmSuccess?: (value: { count: number }) => void;
    private _unsubscribe: () => void;

    static $inject = [
        '$scope',
        'manualInputsService',
        'loggerService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _manualInputsService: IManualInputsService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this.bulkInputRows = [{ id: 0 }];
        this._unsubscribe = this._$scope.$watch(() => this.bulkInputRows, () => {
            if (this.bulkInputRows && _.some(this.bulkInputRows, row => !!row.viewModel)) {
                this.bulkInputRows = this.bulkInputRows.map(row => {
                    if (row.viewModel) {
                        row.viewModel.isDigital = this.isDigital(row.viewModel);
                        row.viewModel.digitalSet = this.getMatchingDigitalSet(row.viewModel);
                    }
                    return row;
                });
            }
        }, true);
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['initialRange']) {
            const initialRange = changesObj['initialRange'].currentValue;
            if (initialRange) {
                this.initialRange = {
                    beginDate: initialRange.beginDate.clone(),
                    endDate: initialRange.endDate.clone()
                };
            }
        }
    }

    $onDestroy() {
        if (this._unsubscribe) {
            this._unsubscribe();
        }
    }

    addBulkRow() {
        this.bulkInputRows.push({
            id: this.bulkInputRows.length > 0 ? d3.max(this.bulkInputRows, r => r.id) + 1 : 0
        });
    }

    deleteBulkRow(id: number) {
        //this.bulkInputRows.splice(id, 1);
        _.remove(this.bulkInputRows, r => r.id === id);
    }

    postBulkEdit() {
        this.isLoading = true;
        const args: IBulkManualInputValues = {
            beginDate: this.currentBeginDate,
            endDate: this.currentEndDate,
            values: this.bulkInputRows,
            includeEndDate: this.includeEndDate
        };
        this._manualInputsService.saveRange(args)
            .then(count => {
                if (this.confirmSuccess) {
                    this.confirmSuccess({ count });
                }
                //this.refresh();
            })
            .catch(reason => {
                this._loggerService.logError('Cannot bulk insert manual inputs', true, reason);
            })
            .finally(() => this.isLoading = false);
    }

    filterTag(list: IValueViewModel[]): IValueViewModel[] {
        const manuals = this.inputList.map(i => i.guid);
        list = list.filter(t => manuals.indexOf(t.guid) >= 0);
        return list;
    }

    private isDigital(rowViewModel: any): boolean {
        return this.digitalsSets
            && rowViewModel
            && rowViewModel.dataType === DataType.Digital
            && rowViewModel.digitalSetGuid
            && rowViewModel.digitalSetGuid !== guidEmpty
            && _.some(this.digitalsSets, ds => ds.guid === rowViewModel.digitalSetGuid);
    }

    private getMatchingDigitalSet(rowViewModel: any): KeyValuePair<any, string>[] {
        let digitalSet: KeyValuePair<any, string>[] = [];
        if (rowViewModel.isDigital) {
            const foundDigitalSet = _.find(this.digitalsSets, ds => ds.guid === rowViewModel.digitalSetGuid);
            if (foundDigitalSet) {
                digitalSet = foundDigitalSet.stateCollection.map(state => {
                    return { key: state.code, value: state.name };
                });
            }
        }
        return digitalSet;
    }
}

export const wtManualBulkInputModal: ComponentDefinition = {
    componentId: 'wtManualBulkInputModal',
    controller: ManualBulkInputModalController,
    template: require('./manualBulkInputModal.component.html'),
    controllerAs: 'vm',
    bindings: {
        modalId: '@',
        initialRange: '<',
        confirmSuccess: '&?',
        isLoading: '=?',
        includeEndDate: '<?',
        inputList: '<',
        digitalsSets: '<'
    }
};
